// @ts-ignore
import {getAndProcessFAQData} from '@ibibo/gi-faq';
import {setVerticalFooterData} from '@ibibo/footer/src/footer-data';

import {fillStoreForDetail} from '@ibibo/hotels-fillstore';
import {updateInitialData} from '@ibibo/hotels-thankyou-reducer';

import configFromEnv from '@ibibo/config-from-env';
import {
  getHomeSeoMetaFromInmemory,
  setHomeSeoMetaToInMemory,
} from '@ibibo/home-seo-meta-to-inmemory';

import {AppState} from './../store';

import ReviewPageLoaders from '../../stories/components/hotels/Loadingpage/ReviewPageLoaders/ReviewPageAllLoaders';

import HomePage from '../pages/HomePage/HomePage';
import {updateSEOData} from '../pages/HomePage/redux/actions';

import SRP from '../pages/SRP/SRP';
import {parseSrpUrlToConfig} from '../pages/SRP/utils/parseSrpUrlToConfig';
import {ISrpQueryParams, ISrpConfig} from '../pages/SRP/redux/types';
import {updateSrpConfigAction} from '../pages/SRP/redux/actions';
import {parseMetaUrlToConfig} from '../pages/SRP/utils/parseMetaUrlToConfig';

import DetailsPage from '../pages/DetailsPage/DetailsPage';
import {parseDetailsPageUrlToConfig} from '../pages/DetailsPage/utils/parseDetailsPageUrlToConfig';
import {IUpdate_Details_Config_Action, DetailStaticShape} from './../pages/DetailsPage/redux/types';
import {
  updateDetailsPageConfigAction,
  updateDetailsStaticData,
} from './../pages/DetailsPage/redux/actions';
import {prepareDetailsPageStaticDataCall} from '../pages/DetailsPage/utils/prepareDetailsPageStaticDataCall';

import ReviewPage from '../pages/ReviewPage/ReviewPage';
import {parseReviewPageUrlToConfig} from '../pages/ReviewPage/utils/parseReviewPageUrlToConfig';

import ThankYouPage from '../pages/ThankYouPage/ThankYou';

import {updateQueryAction} from '../pages/common/redux/actions';
import {IUpdate_Query} from '../pages/common/redux/types';
import {hotelsPartnerFn} from '../pages/common/redux/selectors';

import {
  userReviewDetailType,
  updateUserReview,
  updateHasUserReview,
  updateReviewDataStatus,
} from '../pages/UGC/redux/actions';
// import { detailsRouteRegexes } from '../config/app-config';
import {hotelReviewActions} from '@ibibo/hotels-review-reducer';
import D404 from '@ibibo/d404';
import {detailHttpCode, detailUrlFromStaticData} from '../pages/DetailsPage/selectors/index';
import {redisConfig, redisPort} from '../config/infra-config';
import {metaCookieName} from '../config/app-config';
import logger from 'logger';
import {getRedirectUrl} from '../../../../onboarding/src/store/actions/thunk';

export default [
  {
    path: '/:partner',
    component: HomePage,
    key: 'agenthotelsHomePage',
    actionsBeforeRenderOnServer: ({}) => {
      return {
        redirectUrl: 'https://www.makemytrip.com/hotels/',
        status: 301,
      };
    },
    onServerInit: () => {
      setHomeSeoMetaToInMemory(['hotels_home_seo_meta', 'gostays_home_seo_meta'], false);
      setVerticalFooterData('hotel');
    },
    exact: true,
    populateStoreFromUrl: ({params, searchString}, dispatch) =>
      dispatch(
        updateQueryAction({
          partner: `${params.partner}/${params.version}`,
        } as IUpdate_Query['actionData']),
      ),
    fillStoreOnServer: ({state}) => {
      hotelsPartnerFn(state) === 'hotels'
        ? getAndProcessFAQData('dh_home_json', false)
        : getAndProcessFAQData('gostays_home_json_v2', false);
      updateSEOData(
        getHomeSeoMetaFromInmemory(
          hotelsPartnerFn(state) === 'hotels' ? 'hotels_home_seo_meta' : 'gostays_home_seo_meta',
        )?.desktop,
      );
    },
    toBeCached: true,
    cacheConfig: {
      getCacheKey: ({params}) => `${params.partner}_homepage`,
    },
  },
  {
    path: '/:partner/:version/find-hotels-in-:cityName?/:cityId/:entityId/:hotelQuery?',
    component: SRP,
    key: 'hotelSRP',
    populateStoreFromUrl: ({params, searchString}, dispatch) => {
      const parsedSrpConfig = parseSrpUrlToConfig(searchString, params as ISrpQueryParams);
      const {filter, checkin, checkout, destination, roomString, metaPartner} = parsedSrpConfig;
      dispatch(
        updateQueryAction({
          destination,
          checkin,
          checkout,
          roomString,
          partner: `${params.partner}/${params.version}`,
          metaPartner,
        } as IUpdate_Query['actionData']),
      );
      dispatch(updateSrpConfigAction(filter as ISrpConfig));
    },
    exact: true,
    toBeCached: true,
    cacheConfig: {
      getCacheKey: ({params}) => `hotels_dynamic_srp_${params.cityId}_${params.entityId}`,
    },
  },
  {
    path: '/:partner/:version/meta/:metaPartner/:cityId/:hotelId?/:hquery?',
    component: SRP,
    key: 'hotelMetaSRP',
    populateStoreFromUrl: ({params, searchString}, dispatch) => {
      const parsedSrpConfig = parseMetaUrlToConfig(searchString, params);
      const {
        filter,
        checkin,
        checkout,
        destination,
        roomString,
        overriderankvhids,
        metaPartner,
        ibp,
      } = parsedSrpConfig;
      dispatch(
        updateQueryAction({
          destination,
          checkin,
          checkout,
          roomString,
          partner: `${params.partner}/${params.version}`,
        } as IUpdate_Query['actionData']),
      );
      dispatch(
        updateSrpConfigAction({
          ...filter,
          overriderankvhids,
          metaPartner,
          ibp,
        } as ISrpConfig),
      );
    },
    actionsBeforeRenderOnServer: ({
      params,
    }: {
      params: {
        metaPartner?: string;
        utm_campaign?: string;
        utm_source?: string;
        utm_medium?: string;
      };
    }) => {
      try {
        const cookies = [];
        const {metaPartner = ''} = params;
        const cookieName = metaCookieName;
        const today = new Date();
        const timeStamp = 24 * 60 * 60 * 1000;
        // const meta_partner = query && query.metaTraffic ? query.metaTraffic : '';
        // const metaPartner = params && params.metaPartner ? params.metaPartner : meta_partner;
        if (metaPartner) {
          // newrelic.addCustomAttributes({metaPartner});
          const {utm_campaign = ''} = params;
          let {utm_source = '', utm_medium = ''} = params || {};
          if (!utm_source || !utm_medium) {
            switch (metaPartner) {
              case 'google':
                utm_source = 'google';
                utm_medium = utm_medium ? utm_medium : 'cpc_hpa';
                break;
              case 'trivago':
                utm_source = 'meta';
                utm_medium = utm_medium ? utm_medium : 'Trivago_DH';
                break;
              case 'tripadvisor':
                utm_source = 'meta';
                utm_medium = utm_medium ? utm_medium : 'Tripadvisor_DH';
                break;
              default:
                utm_source = '(not set)';
                utm_medium = '(not set)';
            }
          }
          const cookieDataSm = utm_source + ' / ' + utm_medium + ' / ' + utm_campaign;
          const cookieData = {
            sm: cookieDataSm,
            t: today.getTime(),
          };

          cookies.push({
            name: cookieName,
            value: JSON.stringify(cookieData),
            options: {
              domain: '.goibibo.com',
              maxAge: timeStamp,
            },
          });
        } else {
          cookies.push({
            name: cookieName,
            value: JSON.stringify({sm: 'direct/none/NA', t: ''}),
            options: {
              domain: '.goibibo.com',
              maxAge: timeStamp,
            },
          });
        }
        return {cookies};
      } catch (err) {
        logger.error({
          type: 'cookie',
          label: 'metaCookie',
          msg: err,
        });
      }
    },
    exact: true,
  },
  {
    path: [
      '/:partner/:version/:hotelNameSlug+-in-:cityName?-:hotelId(\\d+)/:hotelQuery?',
      '/:partner/:version/detail/:cityName/:hotelName/:cityId/:hotelId/(:vendorId(/:hquery(/:fwdp(/:pricedet))))',
    ],
    component: DetailsPage,
    key: 'hotelDetails',
    populateStoreFromUrl: ({params, searchString}, dispatch) => {
      const parsedConfig = parseDetailsPageUrlToConfig(searchString, params);
      const searchQuery = new URLSearchParams(searchString);
      const pageString = searchQuery.get('page') || '1';
      const page = parseInt(pageString, 10);
      const {offset = 0, limit = 5} = page === 1 ? {} : {offset: 5 + (page - 2) * 25, limit: 25};
      dispatch(
        updateQueryAction({
          destination: {
            _id: parsedConfig.selectedHotelStatic.hc,
            n: parsedConfig.selectedHotelStatic.hn,
            t: 'hotel',
          },
          checkin: parsedConfig.checkin,
          checkout: parsedConfig.checkout,
          roomString: parsedConfig.roomString,
          partner: `${params.partner}/${params.version}`,
          metaPartner: parsedConfig.metaPartner,
        } as IUpdate_Query['actionData']),
      );

      dispatch(
        updateDetailsPageConfigAction({
          ...parsedConfig,
          page,
        } as IUpdate_Details_Config_Action['actionData']),
      );
      dispatch(
        userReviewDetailType({
          offset,
          limit,
          tagIds: [],
          filter: '',
          sortBy: '',
          page,
        }),
      );
    },
    fillStoreOnServer: fillStoreForDetail,
    fillStoreWaitTime: 5000,
    exact: true,
    toBeCached: true,
    cacheConfig: {
      getCacheKey: ({params, searchString}) => {
        const searchQuery = new URLSearchParams(searchString);
        const pageString = searchQuery.get('page') || '1';
        return `hotels_detail_${params.hotelId}_${pageString}`;
      },
    },
    actionsBeforeRenderOnServer: ({state, params, searchString}) => {
      let status = detailHttpCode(state);
      const {hotelNameSlug, cityName, hotelId, partner, version} = params;
      const hotel_url_from_request = `${hotelNameSlug}-in-${cityName}-${hotelId}`;
      const hotel_url = detailUrlFromStaticData(state) || hotel_url_from_request;
      let redirectUrl;
      if (hotel_url.toLowerCase() !== hotel_url_from_request.toLowerCase()) {
        redirectUrl = `/${partner}/${version}/${hotel_url}/${searchString}`;
        status = 301;
      }
      return {
        status,
        redirectUrl,
      };
    },
  },
  {
    path: ['/:partner/:version/hotel-booking/'],
    component: ReviewPage,
    key: 'reviewPage',
    populateStoreFromUrl: ({params, searchString}, dispatch) => {
      const parsedConfig = parseReviewPageUrlToConfig(searchString);
      dispatch(
        updateQueryAction({
          checkin: parsedConfig.checkin,
          checkout: parsedConfig.checkout,
          roomString: parsedConfig.roomString,
          destination: parsedConfig.destination,
          partner: `${params.partner}/${params.version}`,
        } as IUpdate_Query['actionData']),
      );

      dispatch(
        hotelReviewActions.updateDescblockInput({
          ...parsedConfig.input,
        }),
      );
    },
    exact: true,
    // showHeader: true,
    // showFooter: false,
  },
  {
    path: ['/:partner/:version/thank-you/'],
    component: ThankYouPage,
    key: 'reviewPage',
    populateStoreFromUrl: ({params, searchString}, dispatch) => {
      console.log('hotel_thankyou: searchString = ', searchString);
      const searchQuery = new URLSearchParams(searchString);
      console.log('hotel_thankyou: searchQuery = ', searchQuery);
      const id = searchQuery.get('vertical_txn_id') || '';
      console.log('hotel_thankyou: id = ', id);
      dispatch(
        updateInitialData({
          id: id,
        }),
      );
    },
    exact: true,
  },
  {
    path: '/:partner/hotel-listing',
    key: 'newListingPage',
    actionsBeforeRenderOnServer: async ({request}) => await getRedirectUrl(request),
  },
  {
    path: '/:partner/hotel-details',
    key: 'newDetailsPage',
    actionsBeforeRenderOnServer: async ({request}) => await getRedirectUrl(request),
  },
  {
    path: '*',
    component: D404,
    key: 'hotels404',
  },
];
